export default __webpack_public_path__ + "static/media/swaggy.54f1b548.png";